import { HEADERS } from '@fareye/utils'
import { KPI_COLORS as KPI_COLORS_COMMON } from '@fareye/configs'

export const columnMapping: any = {
  eta: 'eta',
  tripID: 'invoice_no',
  tripIdAndProduct: 'invoice_no',
  startAndEndTime: 'start_date',
  materialTab: 'material',
  vehicleNo: 'vehicle_no',
  routeDetails: 'origin',
  transporterDetails: 'transporter',
  origin: 'origin',
  destination: 'destination',
  transporter: 'transporter',
  consignee: 'consignee_name',
  consigner: 'consigner_name',
  invoiceNo: 'invoice_no',
  status: 'status',
  sta: 'eta'
}

export const KPI_COLORS = {
  'Within TAT': 'rgba(39, 155, 78, 1)',
  'Exceeding TAT': 'rgba(200, 64, 49, 1)',
  ...KPI_COLORS_COMMON
}
//Ontime,Early,Delayed,delayed,Unknown,untracked,untracked_state,
//untracked_status,on_time,OnTime,On_time, in_transit,at_loading
//changed
export const TIMEZONE_KEY = '@IDV:transportation-timezone'
export const headers = {
  headers: HEADERS()['HEADER_INFLECTION']
}

export const TIME_FMT_24_HRS_KEY = '@IDV:time-format-24-hrs'
